// src/components/ProtectedRoute.tsx
import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  path: string;
  exact?: boolean;
  requiredRole?: string; // opcional: "admin" o "empleado"
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, requiredRole, ...rest }) => {
  const [auth, setAuth] = useState<{ checked: boolean; loggedIn: boolean; role?: string }>({
    checked: false,
    loggedIn: false,
  });

  useEffect(() => {
    fetch("https://kevhel.com/api/checklogin.php", {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.logged_in) {
          setAuth({ checked: true, loggedIn: true, role: data.role });
        } else {
          setAuth({ checked: true, loggedIn: false });
        }
      })
      .catch(() => setAuth({ checked: true, loggedIn: false }));
  }, []);

  if (!auth.checked) return <p>Cargando...</p>;

  if (!auth.loggedIn) return <Redirect to="/empleados" />;

  if (requiredRole && auth.role !== requiredRole) {
    return <Redirect to="/empleados" />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default ProtectedRoute;